import React from "react";
import Modal from "components/modal";
import { 
  MdPerson, 
  MdCalendarToday, 
  MdAttachMoney, 
  MdDescription, 
  MdLocationOn,
  MdPhone, 
  MdEdit, 
  MdDelete, 
  MdOutlineCalendarMonth 
} from "react-icons/md";

const SosialyDetailModal = ({ isOpen, onClose, sosialy, onEdit, onDelete }) => {
  // Formatage de la date
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (error) {
      return dateString;
    }
  };

  // Fonction pour formater le montant en devise (MGA)
  const formatCurrency = (amount) => {
    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) return "0 Ar";
    
    return new Intl.NumberFormat('fr-MG', {
      style: 'currency',
      currency: 'MGA',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numAmount);
  };

  if (!sosialy) return null;
  
  const membre = sosialy.membre || {};

  return (
    <Modal isOpen={isOpen} onClose={onClose} width="lg">
      <div>
        <div className="mb-6">
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 mb-1">
                Cotisation - {sosialy.mois_sosialy} {sosialy.annee_sosialy}
              </h2>
              <div className="flex items-center text-sm text-gray-600">
                <MdCalendarToday className="mr-1 h-4 w-4" />
                <span>Enregistrée le {formatDate(sosialy.date_sosialy)}</span>
              </div>
            </div>
            <div className="text-right">
              <div className="text-xl font-bold text-green-700">
                {formatCurrency(sosialy.montant_sosialy)}
              </div>
            </div>
          </div>
          <div className="h-1 w-16 bg-green-600 mt-4 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="space-y-4">
            <div className="flex items-start">
              <MdPerson className="h-5 w-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Membre</h3>
                <p className="text-base text-gray-900">{membre.nom_prenom_membre || "—"}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdLocationOn className="h-5 w-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Origine</h3>
                <p className="text-base text-gray-900">{membre.com_origin || "—"}</p>
              </div>
            </div>

            <div className="flex items-start">
              <MdPhone className="h-5 w-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Téléphone</h3>
                <p className="text-base text-gray-900">{membre.tel_membre || "—"}</p>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <div className="flex items-start">
              <MdOutlineCalendarMonth className="h-5 w-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Période</h3>
                <p className="text-base text-gray-900">
                  {sosialy.mois_sosialy} {sosialy.annee_sosialy}
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <MdAttachMoney className="h-5 w-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Montant</h3>
                <p className="text-base font-medium text-green-700">
                  {formatCurrency(sosialy.montant_sosialy)}
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <MdDescription className="h-5 w-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-medium text-gray-700">Objet</h3>
                <p className="text-base text-gray-900">
                  {sosialy.objet_sosialy}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-3">
          <button
            type="button"
            onClick={onEdit}
            className="inline-flex items-center px-4 py-2 rounded-md text-green-700 bg-green-100 hover:bg-green-200 border border-transparent"
          >
            <MdEdit className="mr-2 h-4 w-4" />
            Modifier
          </button>
          <button
            type="button"
            onClick={onDelete}
            className="inline-flex items-center px-4 py-2 rounded-md text-red-700 bg-red-100 hover:bg-red-200 border border-transparent"
          >
            <MdDelete className="mr-2 h-4 w-4" />
            Supprimer
          </button>
          <button
            type="button"
            className="px-4 py-2 rounded-md text-gray-600 border border-gray-300 bg-white hover:bg-gray-50 transition-colors"
            onClick={onClose}
          >
            Fermer
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SosialyDetailModal;